import type { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";
import { isGuestFoldersAffiliation } from "@Front/Utils/preferredRealOfficeUidHelpers";

/**
 * Lorsque la liste affichée est « dossiers invités », le contexte JWT/API peut porter l’office hôte du dossier :
 * ne pas écraser l’état store (sentinel invité + office métier résolu ailleurs).
 */
export function shouldSkipContextSyncWhenGuestListAndHostOfficeIncoming(opts: {
	activeOffice: UserOfficeAffiliation | null;
	incoming: string | null;
}): boolean {
	const { activeOffice, incoming } = opts;
	return (
		activeOffice != null &&
		isGuestFoldersAffiliation(activeOffice) &&
		incoming != null &&
		!isGuestFoldersAffiliation({ office_uid: incoming, uid: incoming })
	);
}
